import throttle from 'lodash/throttle';
import { useCallback, useEffect, useState } from 'react';
import type { MutableRefObject } from 'react';

type Props = {
	children: (isScrolling: boolean) => boolean | string;
	wrapperRef: MutableRefObject<HTMLDivElement | null>;
};

export const IsScrolling = ({ children, wrapperRef }: Props) => {
	const [isScrolling, setIsScrolling] = useState(false);
	let timer: number | null = null;

	const handleScroll = useCallback(() => {
		console.log('scroll');

		if (timer !== null) {
			clearTimeout(timer);
			setIsScrolling(true);
		}

		timer = window.setTimeout(() => {
			setIsScrolling(false);
		}, 1000);
	}, [timer]);

	useEffect(() => {
		const throttleHandleScroll = throttle(handleScroll, 200);
		const div = wrapperRef.current;

		if (div) {
			div.addEventListener('scroll', throttleHandleScroll);
		}

		return () => {
			div?.removeEventListener('scroll', throttleHandleScroll);
		};
	}, []);

	return children(isScrolling);
};
